module.exports = __webpack_public_path__ + "img/midia-maisvoce-1024x1024.2e05deec.png";